var map = {
	"./approved-estimates.svg": 36526,
	"./claim-submitted.svg": 69891,
	"./completed.svg": 26752,
	"./open.svg": 50633,
	"./rejected-estimates.svg": 31669,
	"./request-information.svg": 48321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27143;